(ns frontend.ui.component.lp-portal.report.body.private-equity.holding.new-investment-company.view
  (:require
   [frontend.ui.component.lp-portal.card.view :as card]
   [frontend.ui.component.lp-portal.report.company.financials-chart.view :as financials-chart]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]))

(defn report
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name case-overview-text overview-figures financials]} holding-ui-data]
    [:div
     {:id (str "holding-report-" (:report-id holding-ui-data))}
     [section
      (str holding-name " - new investment")
      nil
      [card/card {:title ""}
       [:<>
        [free-text-card/free-text-section "Case overview" case-overview-text props]
        [financials-chart/financials-chart financials props]]
       [tabular-card/raw-stacked-table overview-figures props]]]]))

(defn dasos-report
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name case-overview-text overview-figures financials]} holding-ui-data]
    [:div
     {:id (str "holding-report-" (:report-id holding-ui-data))}
     [section
      (str holding-name)
      nil
      [card/card {:title ""}
       [:<>
        [free-text-card/free-text-section "Case overview" case-overview-text props]
        [financials-chart/financials-chart financials props]]
       [tabular-card/raw-stacked-table overview-figures props]]]]))
